import React from "react";
import ReactDOM from "react-dom/client";
import "./fonts";
import "@/index.css";
import App from "@/App";

// After a new deploy, an old cached bundle may ask for chunks that no longer exist:
// reload once to fetch the current build instead of leaving the user on a broken page.
const _isChunkError = (m) => /Loading chunk|ChunkLoadError|Loading CSS chunk|dynamically imported module/i.test(String(m || ""));
const _reloadOnce = () => {
  try {
    if (sessionStorage.getItem("chunk-reloaded")) return;
    sessionStorage.setItem("chunk-reloaded", "1");
  } catch (e) { /* ignore */ }
  window.location.reload();
};
window.addEventListener("error", (e) => { if (_isChunkError(e.message)) _reloadOnce(); });
window.addEventListener("unhandledrejection", (e) => { if (_isChunkError(e.reason && (e.reason.message || e.reason))) _reloadOnce(); });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
